import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { CereriService } from './cereri.service';
import { CereriDetaliiComponent } from './cereri-detalii/cereri-detalii.component';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { environment } from 'src/environments/environment';
import { Observable, Subject, catchError, distinctUntilChanged, finalize, map, of, switchMap, takeUntil, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/utils/services/dialog.service';
import { initializeEditor } from 'src/app/utils/angular-editor/editorConfig';
import { Generic } from 'src/app/interfaces/generic.interface';
import { DataTableDirective } from 'angular-datatables';
import { helper } from 'src/environments/helper';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import * as $ from 'jquery';
import { FormControl, FormGroup } from '@angular/forms';
import { MatCalendar } from '@angular/material/datepicker';
import { ICerereListDT } from './cereri.interface';
import { NotificationService } from 'src/app/services/notification.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppFilesService } from 'src/app/services/app-files.service';
import { CommonService } from 'src/app/services/common.service';
import { AddProgramareComponent } from './add-programare/add-programare.component';
import { LocatiiService } from '../ghiseul-unic-settings/locatii/locatii.service';
import { TipProgramService } from '../ghiseul-unic-settings/tip-program/tip-program.service';
import { TipProblemaService } from '../ghiseul-unic-settings/tip-problema/tip-problema.service';
import { OperatoriService } from '../ghiseul-unic-settings/operatori/operatori.service';
import { DirectiiService } from '../../settings-sidenav/directii/directii.service';
import { CompartimenteService } from '../../settings-sidenav/compartimente/compartimente.service';
import { formatDate } from '@angular/common';
import { StatusService } from '../ghiseul-unic-settings/status/status.service';

@Component({
    selector: 'app-cereri',
    templateUrl: './cereri.component.html',
    styleUrls: ['./cereri.component.scss'],
})
export class CereriComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    @ViewChild(PopoverDirective) popover!: PopoverDirective;
    helper = helper;
    editorConfig!: AngularEditorConfig;
    isLoading = false;
    isFilterLoading = false;
    showCard = false;

    // Popover dates

    @ViewChild('startCalendar') startCalendar!: MatCalendar<Date>;
    @ViewChild('endCalendar') endCalendar!: MatCalendar<Date>;

    today: Date = new Date();
    tomorrow: Date = new Date();
    selectedStartDate: Date = new Date(new Date().getFullYear(), 0, 1);
    private _selectedEndDate: Date = new Date(new Date().getFullYear(), 11, 31);
    selectedFilteringButton: string = 'current_year';

    // Last day of the current year
    lastDayOfYear: Date = new Date(new Date().getFullYear(), 11, 31);
    lastDayOfNextYear: Date = new Date(new Date().getFullYear() + 1, 11, 31);

    setLastXDays(numberOfDays: number): void {
        const date = new Date();
        date.setDate(this.today.getDate() - numberOfDays);
        this.selectedStartDate = date;
        this.updateCalendarView(this.startCalendar, date);
        this.selectedEndDate = this.today;
        this.updateCalendarView(this.endCalendar, this.today);
        this.rerenderDT();
        this.selectedFilteringButton = `last_${numberOfDays}_days`;
    }

    setToday(): void {
        this.selectedStartDate = this.today;
        this.updateCalendarView(this.startCalendar, this.today);
        this.selectedEndDate = this.today;
        this.updateCalendarView(this.endCalendar, this.today);
        this.rerenderDT();
        this.selectedFilteringButton = `today`;
    }

    setNextXDays(numberOfDays: number): void {
        this.selectedStartDate = this.today;
        this.updateCalendarView(this.startCalendar, this.today);
        const date = new Date();
        date.setDate(this.today.getDate() + numberOfDays);
        this.selectedEndDate = date;
        this.updateCalendarView(this.endCalendar, date);
        this.rerenderDT();
        this.selectedFilteringButton = `next_${numberOfDays}_days`;
    }

    setYear(yearsBack: number): void {
        const year = this.today.getFullYear() - yearsBack;
        this.selectedStartDate = new Date(year, 0, 1); // 1 Ianuarie
        this.updateCalendarView(this.startCalendar, this.selectedStartDate);
        this.selectedEndDate = this.lastDayOfYear;
        this.updateCalendarView(this.endCalendar, this.lastDayOfYear);
        this.rerenderDT();
        this.selectedFilteringButton =
            yearsBack === 0 ? 'current_year' : 'previous_year';
    }

    setTodayToEndYear(): void {
        this.selectedStartDate = this.today;
        this.updateCalendarView(this.startCalendar, this.today);
        this.selectedEndDate = this.lastDayOfYear;
        this.updateCalendarView(this.endCalendar, this.lastDayOfYear);
        this.rerenderDT();
        this.selectedFilteringButton = 'today_to_end_year';
    }

    updateCalendarView(calendar: MatCalendar<Date>, date: Date): void {
        if (calendar) {
            calendar.activeDate = date;
        }
    }

    // Methods used to dinamically select the start date according to the end date

    get selectedEndDate(): Date {
        return this._selectedEndDate;
    }

    set selectedEndDate(date: Date) {
        this._selectedEndDate = date;
        if (this.selectedStartDate > date) {
            this.selectedStartDate = new Date(date);
        }
    }

    // Date popover filtering

    dateFilteringOptions: { id: number; value: string }[] = [
        { id: 1, value: 'Adăugare' },
        { id: 2, value: 'Actualizare' },
        { id: 3, value: 'Validare' },
        { id: 4, value: 'Invalidare/Anulare' },
        { id: 5, value: 'Data programare' },
    ];

    dateFilterOption: number = 1;

    statusParametersValue!: string;
    categoryParametersValue!: string;
    notificationParameter: { id: string; name: string } = { id: '-1', name: '' };

    notificationServiceBefore: any = {
        currentStatus: -1,
        currentCategory: -1,
    }

    // Values for status filtering

    defaultParameter: { name: string; id: number } = {
        name: 'Toate',
        id: -1,
    };

    filterParameter: { name: string; id: number } = {
        name: '-- Alegeți --',
        id: -1,
    };

    validationParameters: { name: string; id: number }[] = [
        { name: 'Toate', id: -1 },
        { name: 'Validată', id: 1 },
        { name: 'Invalidată', id: 2 },
        { name: 'Anulată', id: 3 },
        { name: 'Necesită atenție', id: 4 },
    ];

    sourceOptions: { name: string; id: number }[] = [
        { name: 'Toate', id: -1 },
        { name: 'INTERN', id: 5 },
        { name: 'PORTAL', id: 4 },
    ];

    // Vaue for status filtering
    selectedStatusID: number = this.defaultParameter.id;

    // Values for category filtering
    categoryToggleOptions = [
        { id: -1, value: 'Toate' },
        { id: 1, value: 'Departamentele mele' },
        { id: 2, value: 'Solicitările mele' },
        { id: 3, value: 'Mesaje interne' },
    ];

    selectedCategory: string | number = this.categoryToggleOptions[0].id;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    directiiActive: Generic[] = [];
    compartimenteActive: Generic[] = [];
    usersActive: Generic[] = [];

    private addDestroy$ = new Subject<void>();

    filteredDirectii: any[] = [];
    directiiControl = new FormControl();

    filteredCompartimente: any[] = [];
    compartimenteControl = new FormControl();

    filteredUsers: any[] = [];
    usersControl = new FormControl();

    statusuriCerere!: any[];
    tipuriProgramari!: Generic[];
    tipuriProblema!: Generic[];
    locatii!: Generic[];

    parameters: { key: string; value: string }[] = [
        { key: '-- Alegeți --', value: '-1' },
        { key: 'Da', value: '1' },
        { key: 'Nu', value: '0' },
    ];

    toggleCard() {
        this.showCard = !this.showCard;
    }

    closePopover(): void {
        if (this.popover) {
            this.popover.hide();
        }
    }

    searchParamsForm!: FormGroup;

    //Form Initial Values
    initialFormValues = {
        directie_id: -1,
        compartiment_id: -1,
        id_tip_programare: -1,
        id_tip_problema: -1,
        id_cerere: '',
        nume_cetatean: '',
        cnp_cetatean: '',
        telefon_cetatean: '',
        email_cetatean: '',
        source: -1,
        responsible_id: -1,
        id_locatie: -1,
    };

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            directie_id: new FormControl(-1),
            compartiment_id: new FormControl(-1),
            id_tip_programare: new FormControl(-1),
            id_tip_problema: new FormControl(-1),

            id_cerere: new FormControl(''),
            nume_cetatean: new FormControl(''),
            cnp_cetatean: new FormControl(''),
            telefon_cetatean: new FormControl(''),
            email_cetatean: new FormControl(''),

            source: new FormControl(-1),
            responsible_id: new FormControl(-1),
            id_locatie: new FormControl(-1),
        });
    }

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValues);
        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.showCard = false;
        this.rerenderDT(true);
    }

    get activeFiltersCount(): number {
        if (!this.searchParamsForm) return 0;

        const values = this.searchParamsForm.value;
        let count = 0;

        // Select filters (active when !== -1)
        if (values.directie_id !== -1) count++;
        if (values.compartiment_id !== -1) count++;
        if (values.id_tip_programare !== -1) count++;
        if (values.id_tip_problema !== -1) count++;
        if (values.source !== -1) count++;
        if (values.responsible_id !== -1) count++;
        if (values.id_locatie !== -1) count++;

        // Text filters (active when not empty)
        if (values.id_cerere && values.id_cerere.toString().trim() !== '') count++;
        if (values.nume_cetatean && values.nume_cetatean.trim() !== '') count++;
        if (values.cnp_cetatean && values.cnp_cetatean.trim() !== '') count++;
        if (values.telefon_cetatean && values.telefon_cetatean.trim() !== '') count++;
        if (values.email_cetatean && values.email_cetatean.trim() !== '') count++;

        return count;
    }

    dtLink =
        environment.interop.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.listDT;

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private statusService: StatusService,
        private directiiService: DirectiiService,
        private compartimenteService: CompartimenteService,
        private operatoriService: OperatoriService,
        private locatiiService: LocatiiService,
        private tipProgramService: TipProgramService,
        private tipProblemaService: TipProblemaService,
        public permissionsService: PermissionsService,
        private notificationService: NotificationService,
        private router: Router,
        private route: ActivatedRoute,
    ) {
        this.tomorrow.setDate(this.today.getDate() + 1);
    }

    ngOnInit(): void {
        this.renderDT();
        this.loadCerereStatuses();
        this.loadDirectiiActive();
        this.loadTipuriProgramari();
        this.loadTipuriProblema();
        this.loadLocatii();

        this.editorConfig = initializeEditor();
        this.buildSearchParamsForm();
        this.filterCategoryOptions();
        setTimeout(() => this.redirectFromNotifications(), 0);

        this.renderFieldsSearch();
        this.loadUsersActive();

        // Auto-open cerere din query param (pentru istoric programări - deschide în tab nou)
        this.route.queryParams.pipe(takeUntil(this.addDestroy$)).subscribe(params => {
            const openCerereId = params['openCerere'];
            if (openCerereId) {
                setTimeout(() => {
                    this.openInfoDialog({ id: +openCerereId } as ICerereListDT);
                }, 500);
            }
        });
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();

        // Reset notification in the BehaviorSubject
        this.notificationService.changeNotificationGhiseu({ id: '-1', name: '' });

        this.addDestroy$.next();
        this.addDestroy$.complete();
    }

    redirectFromNotifications() {
        this.notificationService.currentNotificationGhiseu
            .pipe(takeUntil(this.addDestroy$))
            .subscribe(
                (notification: { id: string; name: string }) => {
                    if (notification && notification.id !== '-1') {
                        // here we need to update our buttons
                        this.notificationServiceBefore.currentStatus = this.selectedStatusID;
                        this.notificationServiceBefore.currentCategory = this.selectedCategory;

                        this.selectedStatusID = -1;
                        if (notification.id === '2' && this.categoryToggleOptions.some(option => option.id === 3)) {
                            this.selectedCategory = 3; // Mesaje interne
                            this.notificationParameter = notification; // Update chip
                        }

                        this.rerenderDT();
                    }
                }
            );
    }

    // removeChip(): void {
    //     // Resets the notification parameter which we send to our backend with -1 so the filter for this particular flag is canceled
    //     this.notificationParameter = { id: '-1', name: '' };

    //     // here we need to update our buttons
    //     this.selectedStatusID = this.notificationServiceBefore.currentStatus;
    //     this.selectedCategory = this.notificationServiceBefore.currentCategory;

    //     this.rerenderDT();
    // }

    renderFieldsSearch() {
        this.directiiControl.valueChanges.pipe(
            takeUntil(this.addDestroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredDirectii = this.directiiActive;
                    return of(this.directiiActive);
                }
                return this.filterDirectii(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredDirectii = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.compartimenteControl.valueChanges.pipe(
            takeUntil(this.addDestroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredCompartimente = this.compartimenteActive;
                    return of(this.compartimenteActive);
                }
                return this.filterCompartimente(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredCompartimente = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.usersControl.valueChanges.pipe(
            takeUntil(this.addDestroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredUsers = this.usersActive;
                    return of(this.usersActive);
                }
                return this.filterUsers(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredUsers = data;
            }),
            catchError(() => of([]))
        ).subscribe();
    }

    normalizeString(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    loadDirectiiActive() {
        this.isFilterLoading = true;
        this.directiiService
            .getDirectiiActive()
            .pipe(finalize(() => (this.isFilterLoading = false)))
            .subscribe({
                next: (res) => {
                    this.directiiActive = res;
                    this.filteredDirectii = res;
                },
                error: (err) => {
                    console.error('Error in get directii active:', err);
                }
            });
    }

    filterDirectii(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.directiiActive.filter(directie =>
            this.normalizeString(directie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    onDirectieSelectClosed() {
        const selectedValue = this.directiiControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredDirectii.some(directie =>
                directie.id === this.searchParamsForm.get('directie_id')?.value
            );

            if (!isSelectedInFilteredList) {
                this.directiiControl.setValue(null);
                this.filteredDirectii = this.directiiActive;
                this.addDestroy$.next();
                this.addDestroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onDirectieChange(directieId: number): void {
        this.searchParamsForm.controls['compartiment_id'].patchValue(-1);
        this.searchParamsForm.controls['responsible_id'].patchValue(-1);

        this.loadUsersActive();

        if (directieId === -1) {
            this.compartimenteActive = [];
            this.filteredCompartimente = [];
        } else {
            this.loadCompartimenteActive(directieId);
        }
    }

    loadCompartimenteActive(directieId?: number) {
        this.isFilterLoading = true;
        let compartimenteObservable$ = directieId
            ? this.compartimenteService.getCompartimenteByDirectieId(directieId)
            : this.compartimenteService.getCompartimenteActive();

        compartimenteObservable$.pipe(
            map((results: any) => [...results]),
            finalize(() => {
                this.isFilterLoading = false;
            })
        ).subscribe({
            next: (res) => {
                this.compartimenteActive = [...res];
                this.filteredCompartimente = [...res];
            },
            error: (err) => {
                console.log(err);
                this.filteredCompartimente = [];
            },
        });
    }

    filterCompartimente(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.compartimenteActive.filter(compartiment =>
            this.normalizeString(compartiment.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    onCompartimentSelectClosed() {
        const selectedValue = this.compartimenteControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredCompartimente.some(compartiment =>
                compartiment.id === this.searchParamsForm.get('compartiment_id')?.value
            );

            if (!isSelectedInFilteredList) {
                this.compartimenteControl.setValue(null);
                this.filteredCompartimente = this.compartimenteActive;
                this.addDestroy$.next();
                this.addDestroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onCompartimentChange(compartimentId: number) {
        this.searchParamsForm.controls['responsible_id'].patchValue(-1);

        this.loadUsersActive();
    }

    loadUsersActive() {
        this.isLoading = true;

        const directie_id = this.searchParamsForm.controls['directie_id'].value;
        const compartiment_id = this.searchParamsForm.controls['compartiment_id'].value;

        this.operatoriService
            .getOperatoriFiltered({ directie_id, compartiment_id, active: true })
            .pipe(
                map((results: any) => [...results]),
                finalize(() => (this.isLoading = false))
            ).subscribe({
                next: (res) => {
                    this.usersActive = [...res];
                    this.filteredUsers = [...res];
                },
                error: (err) => {
                    console.log(err);
                    this.filteredUsers = [];
                },
            })
    }

    filterUsers(searchTerm: string): Observable<Generic[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        return of(this.usersActive.filter(user =>
            this.normalizeString(user.name).includes(normalizedSearchTerm)
        ));
    }

    onUsersSelectClosed() {
        const selectedValue = this.usersControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredUsers.some(user =>
                user.id === this.searchParamsForm.get('responsible_id')?.value
            );

            if (!isSelectedInFilteredList) {
                this.usersControl.setValue(null);
                this.filteredUsers = this.usersActive;
                this.addDestroy$.next();
                this.addDestroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    loadCerereStatuses() {
        this.isFilterLoading = true;
        this.statusService
            .getStatusesActive()
            .pipe(
                map((results: any) => [...results, this.defaultParameter]),
                finalize(() => (this.isFilterLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.statusuriCerere = results;
                },
                error: (error) => {
                    console.error('Error loading request statuses', error);
                    this.isFilterLoading = false;
                },
            });
    }

    loadTipuriProgramari() {
        this.isFilterLoading = true;
        this.tipProgramService
            .getTipuriProgram()
            .pipe(
                map((results: any) => [this.defaultParameter, ...results.data]),
                finalize(() => (this.isFilterLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.tipuriProgramari = results;
                },
                error: (error) => {
                    console.error('Error loading tipuri program', error);
                    this.isFilterLoading = false;
                },
            });
    }

    loadTipuriProblema() {
        this.isFilterLoading = true;
        this.tipProblemaService
            .getTipuriProblema()
            .pipe(
                map((results: any) => [this.defaultParameter, ...results.data]),
                finalize(() => { this.isFilterLoading = false })
            ).subscribe({
                next: (results) => {
                    this.tipuriProblema = results;
                },
                error: (error) => {
                    console.error('Error loading tipuri problema', error);
                    this.isFilterLoading = false;
                },
            });
    }

    loadLocatii() {
        this.isFilterLoading = true;
        this.locatiiService.getLocatii().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isFilterLoading = false))
        ).subscribe({
            next: (results) => {
                this.locatii = results;
            },
            error: (error) => {
                console.error('Error loading locatii', error);
                this.isFilterLoading = false;
            },
        });
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    renderDT() {
        this.isLoading = true;

        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 25,
            order: [[0, 'desc']],

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;

                dataTablesParameters.id_cerere_status = this.selectedStatusID;
                dataTablesParameters.view_filter = this.selectedCategory;

                dataTablesParameters.tip_date = +this.dateFilterOption;
                dataTablesParameters.date_from = this.formatDate(this.selectedStartDate);
                dataTablesParameters.date_to = this.formatDate(this.selectedEndDate);
                // dataTablesParameters.notification = this.notificationParameter.id;
                dataTablesParameters.notification = 0;

                dataTablesParameters.directie_id = this.searchParamsForm.value.directie_id;
                dataTablesParameters.compartiment_id = this.searchParamsForm.value.compartiment_id;
                dataTablesParameters.id_tip_problema = this.searchParamsForm.value.id_tip_problema;
                dataTablesParameters.id_tip_programare = this.searchParamsForm.value.id_tip_programare;

                dataTablesParameters.id_cerere = this.searchParamsForm.value.id_cerere;
                dataTablesParameters.nume_cetatean = this.searchParamsForm.value.nume_cetatean;
                dataTablesParameters.cnp_cetatean = this.searchParamsForm.value.cnp_cetatean;
                dataTablesParameters.telefon_cetatean = this.searchParamsForm.value.telefon_cetatean;
                dataTablesParameters.email_cetatean = this.searchParamsForm.value.email_cetatean;

                dataTablesParameters.source = this.searchParamsForm.value.source;
                dataTablesParameters.responsible_id = this.searchParamsForm.value.responsible_id;
                dataTablesParameters.id_locatie = this.searchParamsForm.value.id_locatie;

                this.http
                    .post<any>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;

                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });

                        if (resp.data.recordsFiltered < dataTablesParameters.start) {
                            this.rerenderDT(true);  // sets dataTablesParameters.start = 0, goes to page 1
                        }
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columnDefs: [
                // { width: '30px', targets: 0 },
                { width: '100px', targets: 9 },
            ],

            columns: [
                {
                    title: 'ID',
                    data: 'id',
                    sortable: true,
                    render: (data: any, type: any, row: any) => {
                        // let flagIcon = '<i class="fa-solid fa-flag" style="color: white;"></i> ';

                        // let source = '';
                        // let color = '';
                        // switch (row.source) {
                        //     case 1:
                        //     case 4:
                        //         source = 'PORTAL';
                        //         color = '#800080';
                        //         break;
                        //     case 2:
                        //         source = 'EMAIL';
                        //         color = '#0000FF';
                        //         break;
                        //     case 3:
                        //         source = 'MOBILE';
                        //         color = '#ffa500';
                        //         break;
                        //     case 5:
                        //         source = 'INTERN';
                        //         color = '#4CAF50';
                        //         break;
                        //     default:
                        //         source = 'EXTERN';
                        //         color = '#2196F3';
                        //         break;
                        // }
                        return `
                            <div style="display: flex; flex-direction: column; gap: 5px; text-nowrap">
                                <span>${row.id}</span>
                            </div>
                        `;
                        // return `
                        //     <div style="display: flex; flex-direction: row; gap: 5px;">
                        //         <span>${row.id_cerere}</span>
                        //         <span style="color: ${color}; font-weight: 700;">${source}</span>
                        //     </div>
                        //     <br/>
                        // 	` + (row.mesajeInterne == 1 ?
                        //         `<div style="display:inline-block; padding: 4px 6px; color: white; background-color: red; border: 0px;border-radius:10px">
                        //                 <span>${flagIcon} Mesaj intern</span>
                        //             </div>`
                        //         : '')
                        //     + `
                        // `;
                    },
                },
                {
                    title: 'Subiect',
                    data: 'subject',
                    sortable: true,
                    render: (data: any, type: any, row: any) => {
                        let html = `${row.subject}`;

                        // Add location if available
                        if (row.locatie_name) {
                            html += `<br/><small style="color: #666;"><i class="fa fa-map-marker"></i> ${row.locatie_name}</small>`;
                        }

                        // Add event date and time if available
                        if (row.event_date) {
                            const eventDate = formatDate(row.event_date, 'dd.MM.yyyy', 'ro-RO');
                            const eventTime = row.event_time ? row.event_time.substring(0, 5) : '';
                            html += `<br/><small style="color: #666;"><i class="fa fa-calendar"></i> ${eventDate}`;
                            if (eventTime) {
                                html += ` <i class="fa fa-clock-o"></i> ${eventTime}`;
                            }
                            html += `</small>`;
                        }

                        // Add source (INTERN/PORTAL)
                        let sourceLabel = '';
                        let sourceColor = '';
                        if (row.source === 5) {
                            sourceLabel = 'INTERN';
                            sourceColor = '#4CAF50'; // green
                        } else if (row.source === 4 || row.source === 1) {
                            sourceLabel = 'PORTAL';
                            sourceColor = '#800080'; // purple
                        } else if (row.source) {
                            sourceLabel = 'EXTERN';
                            sourceColor = '#2196F3'; // blue
                        }
                        if (sourceLabel) {
                            html += `<br/><span style="color: ${sourceColor}; font-weight: 700; font-size: 11px;">${sourceLabel}</span>`;
                        }

                        return html;
                    }
                },
                {
                    title: 'Cetățean',
                    data: 'fullname',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        const name = row.fullname && row.fullname !== " " ? row.fullname : 'n/a';
                        return `<span>${name}</span>`
                    }
                },
                {
                    title: 'Direcție/Serviciu',
                    data: 'section',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `<span>${row.section || 'n/a'}</span>`
                    }
                },
                {
                    title: 'Dată creat',
                    data: 'created_at',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return row.created_at ? `${formatDate(row.created_at, 'dd.MM.yyyy', 'ro-RO')}` : 'n/a'
                    }
                },
                {
                    title: 'Prioritate',
                    data: 'priority_name',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `<span style="border-radius:10px; padding:4px 8px; color: #ffffff; background: ${row.priority_color}; white-space: nowrap">${row.priority_name || 'n/a'}</span>`;
                    },
                },
                {
                    title: 'Responsabil',
                    data: 'user_assigned_name',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `<span>${row.user_assigned_name || 'n/a'}</span>`
                    }
                },
                {
                    title: 'Creator',
                    data: 'user_submit_name',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        let html = '';

                        if (row.source === 5) {
                            // Internal - show operator name and their directie/compartiment
                            html = `<span><i class="fa fa-user"></i> ${row.user_submit_name || 'n/a'}</span>`;
                            if (row.creator_directie) {
                                html += `<br/><small style="color: #666;"><i class="fa fa-building"></i> ${row.creator_directie}</small>`;
                            }
                            if (row.creator_compartiment) {
                                html += `<br/><small style="color: #666;"><i class="fa fa-users"></i> ${row.creator_compartiment}</small>`;
                            }
                        } else {
                            // Portal/External - show as citizen
                            html = `<span><i class="fa fa-user-circle"></i> Cetățean</span>`;
                        }

                        return html;
                    }
                },
                {
                    title: 'Status',
                    data: 'status',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        let label = '';
                        let flagIcon =
                            '<i class="fa-solid fa-flag" style="color: white;"></i> ';
                        if (row.validated_date && !row.cancel_date) {
                            // Validat
                            label = `<span style="border-radius:10px; padding:4px 8px; color: white; background: green; white-space: nowrap">${flagIcon}Validat</span>`;
                        } else if (row.cancel_date && row.cancel_type === 1) {
                            // Invalidat
                            label = `<span style="border-radius:10px; padding:4px 8px; color: white; background: orange; white-space: nowrap">${flagIcon}Invalidat</span>`;
                        } else if (row.cancel_date && row.cancel_type === 2) {
                            // Clasat
                            label = `<span style="border-radius:10px; padding:4px 8px; color: white; background: red; white-space: nowrap">${flagIcon}Clasat</span>`;
                        } else {
                            // Default case
                            label = ``;
                        }
                        return `
                            <span style="border-radius:10px; padding:4px 8px; color: #ffffff; background: ${row.status_color}; white-space: nowrap">${row.status_name}</span>
                            <br/><br/>
                            ${label}
                        `;
                    }
                },
                {
                    title: 'Actualizat',
                    data: 'updated_at_display',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `${row.updated_at_display || 'n/a'}`
                    }
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                $('td', row).off('click');

                $('td:not(:first-child)', row).on('click', () => {
                    this.onRowClick(data);
                });

                return row;
            },
        };
    }

    onRowClick(rowData: ICerereListDT) {
        this.closePopover();
        this.openInfoDialog(rowData);
    }

    rerenderDT(paginate = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
    }

    openInfoDialog(data: ICerereListDT) {
        const dialogRef = this.dialog.open(CereriDetaliiComponent, {
            minHeight: '100vh',
            maxHeight: '100vh',
            minWidth: '100vw',
            maxWidth: '100vw',
            disableClose: true,
            data: {
                cerere: data,
            },
        });

        dialogRef.afterClosed().subscribe(() => {
            this.rerenderDT();
        });
    }

    openAddProgramareDialog() {
        const dialogRef = this.dialog.open(AddProgramareComponent, {
            minHeight: '90vh',
            maxHeight: '90vh',
            minWidth: '900px',
            maxWidth: '900px',
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.rerenderDT();
            }
        });
    }

    onStatusChange(event: MatButtonToggleChange) {
        this.isLoading = true;
        this.selectedStatusID = event.value;

        this.statusParametersValue = event.value === 'toate' ? '-1' : '1';
        this.rerenderDT();
    }

    onCategoryChange(event: MatButtonToggleChange) {
        this.isLoading = true; // Assuming you have an isLoading flag for loading state
        this.selectedCategory = event.value;

        const selectedOption = this.categoryToggleOptions.find(option => option.id === event.value);
        this.categoryParametersValue = selectedOption ? selectedOption.value : 'default';

        // Reset chip
        // this.notificationParameter = { id: '-1', name: '' };

        this.rerenderDT();
    }

    filterCategoryOptions() {
        const permissionMapping: { [key: string]: string } = {
            "-1": "auth-module.ghiseu.list-all",
            // "1": "auth-module.ghiseu.to-approve",
            "1": "auth-module.ghiseu.list-my-departments",
            "3": "auth-module.ghiseu.list-my-requests",
            "2": "auth-module.ghiseu.list-intern-messages",
        };

        // Filter categoryToggleOptions based on permissions
        this.categoryToggleOptions = this.categoryToggleOptions.filter(option =>
            this.permissionsService.hasPermission(permissionMapping[option.id.toString()])
        );

        // Initialize selectedCategory after filtering
        this.selectedCategory = this.categoryToggleOptions[0]?.id;
    }

    onDateFilterChange(): void {
        this.rerenderDT();
    }
}
